import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from 'antd';

import { getOsIcon } from '@app/utils';

import type { NUserPreview } from '@pages/Users/UserPreview/UserPreview.types';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

const { Text } = Typography;

export const ActivityInfo: NUserPreview.ActivityInfo = ({ user }) => {
  return (
    <div className="activity-info-container">
      <div className="activity">
        <Text
          strong
          className="activity-title"
          data-testid="current-branch-title"
        >
          Текущий филиал:
        </Text>
        <Text className="avticity-content" data-testid="current-branch">
          {user?.UserBranches[0]?.Name}
        </Text>
      </div>
      <div className="activity">
        <Text strong className="activity-title" data-testid="time-zone-title">
          Часовой пояс:
        </Text>
        <Text className="avticity-content" data-testid="time-zone">
          {user?.Timezone}
        </Text>
      </div>
      <div className="activity">
        <Text
          strong
          className="activity-title"
          data-testid="last-activity-title"
        >
          Последняя активность:
        </Text>
        <Text className="avticity-content" data-testid="last-activity">
          {user?.LastVisitOs && (
            <FontAwesomeIcon
              icon={getOsIcon(user.LastVisitOs) as IconProp}
              size={'lg'}
              style={{ width: '30px', marginLeft: '-5px' }}
            />
          )}
          {` ${user?.LastVisitS} `}
        </Text>
      </div>
    </div>
  );
};
